(function() {
  'use strict';

  function initCustomFilter() {
    try {
      const colorInputs = document.querySelectorAll('.product-variant__item--color input[type="radio"]');
      const sizeInputs = document.querySelectorAll('.product-variant__item--radio:not(.product-variant__item--color) input[type="radio"]');
      const addToCartBtn = document.querySelector('[data-js-product-add-to-cart]');

      function findMatchingVariant() {
        try {
          if (!window.productVariants) return null;
          const color = document.querySelector('.product-variant__item--color input[type="radio"]:checked')?.value;
          const size = document.querySelector('.product-variant__item--radio:not(.product-variant__item--color) input[type="radio"]:checked')?.value;
          return window.productVariants.find(function(v) {
            return v.option1 === color && v.option2 === size;
          });
        } catch(e) { return null; }
      }

      function updateImages() {
        try {
          if (!window.productVariants) return;
          const selectedColor = document.querySelector('.product-variant__item--color input[type="radio"]:checked')?.value;
          if (!selectedColor) return;
          sizeInputs.forEach(function(input) {
            try {
              const sizeValue = input.value;
              const variant = window.productVariants.find(function(v) {
                return v.option1 === selectedColor && v.option2 === sizeValue;
              });
              const container = input.closest('.product-variant__item')?.querySelector('.product-variant__image-container');
              if (!container) return;
              if (variant && variant.featured_image) {
                container.innerHTML = '<img src="' + variant.featured_image.src + '" alt="' + variant.title + '">';
              } else {
                container.textContent = sizeValue;
              }
            } catch(e) {}
          });
        } catch(e) {}
      }

      function updateProductDetails() {
        try {
          if (!window.productVariants) return;
          const variant = findMatchingVariant();
          if (!variant) return;
          const idInput = document.querySelector('input[name="id"]');
          if (idInput) idInput.value = variant.id;
          if (addToCartBtn) addToCartBtn.disabled = !variant.available;
        } catch(e) {}
      }

      function redirectToRelatedProduct(input) {
        try {
          const url = input.getAttribute('data-url');
          if (url) window.location.href = url;
        } catch(e) {}
      }

      function attachListeners() {
        try {
          [...colorInputs, ...sizeInputs].forEach(function(input) {
            input.addEventListener('change', function() {
              updateImages();
              updateProductDetails();
            });
          });

          document.querySelectorAll('.product-variant__item.product-variant__item--color.related').forEach(function(div) {
            div.addEventListener('click', function() {
              try {
                const input = div.querySelector('.product-variant__input');
                if (input) redirectToRelatedProduct(input);
              } catch(e) {}
            });
          });

          document.addEventListener('variant:changed', function() {
            updateImages();
          });
        } catch(e) {}
      }

      function initPreselectedVariant() {
        try {
          const urlVariantId = new URLSearchParams(window.location.search).get('variant');

          const waitForForm = setInterval(function() {
            try {
              const idInput = document.querySelector('input[name="id"]');
              if (!idInput || !window.productVariants) return;

              clearInterval(waitForForm);

              if (urlVariantId) {
                const input = document.querySelector(
                  'input.product-variant-value[data-variant-id="' + urlVariantId + '"]'
                );
                if (input) {
                  input.checked = true;
                  idInput.value = urlVariantId;
                  input.dispatchEvent(new Event('change', { bubbles: true }));
                }
              } else {
                const firstAvailable = document.querySelector(
                  '.product-variant__item--radio input[type="radio"]:not([disabled])'
                );
                if (firstAvailable) {
                  firstAvailable.checked = true;
                  firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            } catch(e) {
              clearInterval(waitForForm);
            }
          }, 50);

          setTimeout(function() { clearInterval(waitForForm); }, 3000);
        } catch(e) {}
      }

      // Initialize
      attachListeners();

      var waitForVariants = setInterval(function() {
        if (!window.productVariants) return;
        clearInterval(waitForVariants);
        updateImages();
        updateProductDetails();
        initPreselectedVariant();
      }, 50);

      setTimeout(function() { clearInterval(waitForVariants); }, 3000);

    } catch(e) {
      console.warn('custom-filter.js failed to initialize:', e);
    }
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomFilter);
  } else {
    initCustomFilter();
  }

})();